import { Breadcrumbs, Typography } from "@material-ui/core";
import { InstalledAppsTable } from "../InstalledAppsTable";
import { useInstalledAppList } from "../hooks/useInstalledAppList";

export const InstalledAppListTemplate: React.FC = () => {
  const { apps, meta, isLoading } = useInstalledAppList();

  return (
    <>
      <Breadcrumbs>
        <Typography>連携アプリ一覧</Typography>
      </Breadcrumbs>

      <InstalledAppsTable apps={apps} meta={meta} isLoading={isLoading} />
    </>
  );
};
